const GAMES_CONFIG = {
  1: {
    gameUrls: 'https://game.lucky-verse.playtiviti.com/index.json',
    assertsUrl: '',
    logo: '/logo.jpg',
    title: 'LUCKY VERSE',
    subtitle: 'BY PLAYTIVITI',
    telegramUrl: 'https://t.me/LuckyVerseBot',
    shareDefaultText:
      'Hey! 🎉 Join LuckyVerse! 🍀\n\n' +
      '✨ Dive into a world of endless fun and fortune! ✨\n\n' +
      '• TG Premium: +15 $LUCK 🍀\n' +
      '• General: +5 $LUCK 🍀\n\n' +
      '🔥 Ready to roll? 🚀\n',
    diamond: 'Get +15 $LUCK 🍀 by join LuckyVerse!',
    paymentCurrencies: [
      'STARS',
      // 'SOL',
      // 'TOKEN',
      'TON',
      // 'Notcoin',
      // 'Hamster Kombat',
      // 'Catizen',
      // 'Tether USDt',
    ],
    disabledCurrencies: ['SOL', 'TOKEN'],
    adsgramKey: '7406',
    fullScreen: true,
    backendFeatures: {
      save: false,
      balance: false,
    },
    orientation: 'portrait',
  },
  2: {
    gameUrls: {
      loaderUrl:
        'https://games.telelauncher.com/kill-them-all-gzip/public/Build/KillThemAll.loader.js',
      dataUrl:
        'https://games.telelauncher.com/kill-them-all-gzip/public/Build/KillThemAll.data.unityweb',
      frameworkUrl:
        'https://games.telelauncher.com/kill-them-all-gzip/public/Build/KillThemAll.framework.js.unityweb',
      codeUrl:
        'https://games.telelauncher.com/kill-them-all-gzip/public/Build/KillThemAll.wasm.unityweb',
    },
    assertsUrl: 'https://games.telelauncher.com/kill-them-all-gzip/public',
    logo: 'https://raw.githubusercontent.com/dangost/static/refs/heads/master/ST-icon-1.png',
    title: 'Kill Them All',
    subtitle: 'BY PANDAPLAY',
    telegramUrl: 'https://t.me/kill_them_all_bot',
    shareDefaultText: 'Welcome to our application',
    diamond: 'Get 1$ or 50 💎 for FREE by join Kill Them All!',
    paymentCurrencies: ['STARS', 'SOL', 'TOKEN', 'TON'],
    disabledCurrencies: ['SOL', 'TOKEN'],
    adsgramKey: '4167',
    fullScreen: false,
    backendFeatures: {
      save: true,
      balance: true,
    },
    orientation: 'portrait',
  },
  3: {
    gameUrls: {
      loaderUrl:
        'https://games.telelauncher.com/testgame-gzip/Build/TeleLauncherUnity-Gzip.loader.js',
      dataUrl:
        'https://games.telelauncher.com/testgame-gzip//Build/TeleLauncherUnity-Gzip.data.unityweb',
      frameworkUrl:
        'https://games.telelauncher.com/testgame-gzip//Build/TeleLauncherUnity-Gzip.framework.js.unityweb',
      codeUrl:
        'https://games.telelauncher.com/testgame-gzip//Build/TeleLauncherUnity-Gzip.wasm.unityweb',
    },
    assertsUrl: '',
    logo: '/logo.jpg',
    title: 'TIME MASTER',
    subtitle: 'BY PLAYTIVITI',
    telegramUrl: 'https://t.me/TimeMasterCoinBot',
    shareDefaultText: 'Welcome to our application',
    diamond: 'Get 1$ or 50 💎 for FREE by join Time Master!',
    paymentCurrencies: [
      'STARS',
      // 'SOL',
      // 'TOKEN',
      'TON',
      'Notcoin',
      'Hamster Kombat',
      'Catizen',
      'Tether USDt',
    ],
    disabledCurrencies: ['Catizen'],
    adsgramKey: '4167',
    fullScreen: false,
    backendFeatures: {
      save: false,
      balance: false,
    },
    orientation: 'portrait',
  },
  4: {
    gameUrls: 'https://test-game.lucky-verse.playtiviti.com/index.json',
    assertsUrl: '',
    logo: '/logo.jpg',
    title: 'LUCKY VERSE TEST',
    subtitle: 'BY PLAYTIVITI',
    telegramUrl: 'https://t.me/TimeMasterCoinBot',
    shareDefaultText:
      'Hey! 🎉 Join LuckyVerse! 🍀\n\n' +
      '✨ Dive into a world of endless fun and fortune! ✨\n\n' +
      '• TG Premium: +15 $LUCK 🍀\n' +
      '• General: +5 $LUCK 🍀\n\n' +
      '🔥 Ready to roll? 🚀\n',
    diamond: 'Get +15 $LUCK 🍀 by join LuckyVerse!',
    paymentCurrencies: [
      'STARS',
      // 'SOL',
      // 'TOKEN',
      'TON',
      // 'Notcoin',
      // 'Hamster Kombat',
      // 'Catizen',
      // 'Tether USDt',
    ],
    disabledCurrencies: ['SOL', 'TOKEN'],
    adsgramKey: '7406',
    fullScreen: true,
    backendFeatures: {
      save: false,
      balance: false,
    },
    orientation: 'portrait',
  },
};

export default GAMES_CONFIG;
